/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.userRewards.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@ExperimentalJsExport
@JsExport
@Serializable
data class UserRewardsModel(
    /** Contains a list of all rewards available to this user */
    @SerialName("data")
    val data: UserRewardsData?,

    @SerialName("meta")
    val meta: Meta?,

    @SerialName("searchRefinements")
    val searchRefinements: List<SearchRefinement>?,

    @SerialName("refinementMatchCount")
    val refinementMatchCount: Int?
) : Model()
